/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        "key": "tips",
        "value": "公告链接可以拖拽改变顺序",
        "type": "tips"
    },
    {
        "name": "公告",
        "type": "module-name"
    },
    {
        "key": "property_data",
        "name": "属性",
        "type": "custom",
        "content": [{
                "key": "icon_url",
                "name": "公告图标",
                "type": "img",
                "memo": "建议尺寸：60px*60px"
            },
            {
                "key": "background_color",
                "name": "背景颜色",
                "type": "color"
            },
            {
                "key": "font_color",
                "name": "字体颜色",
                "type": "color",
            }
        ],
    },
    {
        "key": "link_data",
        "name": "属性",
        "type": "notice-board"
    }
];
export default config;